import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBObaf_fOa_cxqHU6lq9-nuUvKzJDpX3QU",
  authDomain: "theyaadshop.firebaseapp.com",
  projectId: "theyaadshop",
  storageBucket: "theyaadshop.firebasestorage.app",
  messagingSenderId: "1001353390340",
  appId: "1:1001353390340:web:ff40b60d498d3324494851"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const functions = getFunctions(app, 'us-central1');
export const auth = getAuth(app);
